import angular from 'angular';
import booksServices from '../booksServices';
import CSMCommonWeb from 'csm-common-web';
import CSMBooksWeb from '../../CSMBooksWeb';
import 'angular-route';
import 'angular-named-route';
import { AppRoutesProvider } from './services/AppRoutes';
/** Reset Form */
import {
  ResetFormAppRoutesProvider,
  restFormComponent
} from './routes/reset/resetForm';
/** Login Form */
import {
  LoginFormAppRoutesProvider,
  loginFormComponent
} from './routes/login/loginForm';
/** OAuth */
import {
  OAuthAppRoutesProvider,
  oAuthComponent
} from './routes/login/sso/oauth';
/** Login SSO Google */
import { googleSignInComponent } from './routes/login/sso/google/googleSignIn';
/** Login SSO Microsoft */
import { microsoftSignInComponent } from './routes/login/sso/microsoft/microsoftSignIn';
/** Forgot Password Dialog */
import { ForgotPasswordDialogDirective } from './routes/login/dialogs/ForgotPasswordDialog';
/** Display License Dialog */
import { DisplayLicenseDialogService } from './routes/login/dialogs/DisplayLicenseDialog';

export default angular
  .module('app', [
    booksServices,
    'ui.bootstrap',
    CSMCommonWeb,
    CSMBooksWeb,
    'ngRoute',
    'ngNamedRoute'
  ])
  .config(configureRoutes)
  .run(runInitApp)
  .constant('Routes', {
    login: 'login',
    oauth: 'oauth',
    reset: 'reset'
  })
  .provider('AppRoutes', AppRoutesProvider)
  /** Reset Form */
  .provider('AppRoutes', ResetFormAppRoutesProvider)
  .component('resetForm', restFormComponent)
  /** Login Form */
  .provider('AppRoutes', LoginFormAppRoutesProvider)
  .component('loginForm', loginFormComponent)
  /** Forgot Password TODO: GR-329 - Does not seem to be used. */
  // .provider('AppRoutes', ForgotPasswordAppRoutesProvider)
  /** OAuth */
  .provider('AppRoutes', OAuthAppRoutesProvider)
  .component('oauth', oAuthComponent)
  /** Login SSO Google */
  .component('googleSignIn', googleSignInComponent)
  /** Login SSO Microsoft */
  .component('microsoftSignIn', microsoftSignInComponent)
  /** Forgot Password Dialog */
  .directive('forgotPasswordDialog', ForgotPasswordDialogDirective)
  /** Display EULA  */
  .service('DisplayLicenseDialog', DisplayLicenseDialogService)
  .constant('LABELS_FORGOT', {
    action: 'Send',
    header: 'Forgot your Password?',
    body: 'Resetting your password is simple. Just enter in the email address associated to your account.'
  })
  .constant('LABELS_RESET', {
    action: 'Resend Email',
    header: 'Password Reset',
    body: 'An email has been sent with instructions to continue the reset process.'
  }).name;

/*******************************************************************************
 * Configure.configureRoutes */
/**
 * Set up routes
 *******************************************************************************/
function configureRoutes($routeProvider, $locationProvider, AppRoutesProvider) {
  $locationProvider.hashPrefix('');
  $routeProvider
    .when('/', AppRoutesProvider.login)
    .when('/reset/:token', AppRoutesProvider.reset)

    /*-----------------------------------------------------------------*/
    /* For the oauth route, we need to capture the state and code from */
    /* the oauth provider. The code from Google is slightly annoying   */
    /* because it includes a slash, so we need to add the asterisk (*) */
    /* to the end of that route param definition to make it greedy.    */
    /*-----------------------------------------------------------------*/
    .when('/oauth/:state/:code*', AppRoutesProvider.oauth)
    .otherwise('/');
}

configureRoutes.$inject = [
  '$routeProvider',
  '$locationProvider',
  'AppRoutesProvider'
];

/*******************************************************************************
 * Run.runInitApp */
/**
 * Set up listeners for routing events.
 *******************************************************************************/
function runInitApp($rootScope, $location, BusyScreen) {
  /*--------------------------------------*/
  /* Show/clear BusyScreen on route load. */
  /*--------------------------------------*/
  $rootScope.$on('$routeChangeStart', () => BusyScreen.setBusy(true));
  $rootScope.$on('$routeChangeSuccess', () => BusyScreen.setBusy(false));

  /*-------------------------------------------------------*/
  /* Redirect to the root path when a route fails to load. */
  /*-------------------------------------------------------*/
  $rootScope.$on('$routeChangeError', () => $location.path('/'));
}

runInitApp.$inject = ['$rootScope', '$location', 'BusyScreen'];
